export default __webpack_public_path__ + "static/media/img--elevation-1.07d2499b.jpg";